import { Button, Result, Row } from 'antd'
import Image from 'next/image'
import { useRouter } from 'next/router'
import { useIntl } from 'react-intl'

import { buildI18nFunction } from '@/utils/messages'

import styles from './UnauthorizedResult.module.css'

export function UnauthorizedResult() {
  const t = buildI18nFunction(useIntl().formatMessage)
  const router = useRouter()

  return (
    <Row
      align="middle"
      className={styles['unauthorizedResult']}
      justify="center"
      style={{ height: 'calc(100vh - 80px)' }}
    >
      <Result
        icon={
          <Image
            alt="not-authorized"
            height={280}
            src="/images/illustrations/not-authorized.svg"
            width={280}
          />
        }
        subTitle="Sorry, you are not authorized to access this page."
        title="403"
        extra={
          <Button type="primary" onClick={() => router.replace('/')}>
            {t('Index.RouteProtection.back.button')}
          </Button>
        }
      />
    </Row>
  )
}
